import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { getShiftDate } from "../../util/dateTimeFormatter.js";
import { calculateTimeLeft } from "../../util/bid/shiftBidUtils.js";

const BidTimer = (props) => {
  const [startTimeLeft, setStartTimeLeft] = useState(calculateTimeLeft(props.windowDates[0], props.station));
  const [endTimeLeft, setEndTimeLeft] = useState(calculateTimeLeft(props.windowDates[1], props.station));

  useEffect(() => {
    const timer = setTimeout(() => {
      setStartTimeLeft(calculateTimeLeft(props.windowDates[0], props.station));
      setEndTimeLeft(calculateTimeLeft(props.windowDates[1], props.station));
    }, 1000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  });

  const renderDateAndTimes = (openCloseStatus, timeLeft) => {
    return (
      <div>
        <span>{"Bid " + openCloseStatus + " in"} </span>
        <span>{timeLeft?.days.toLocaleString()} days, </span>
        <span>{timeLeft?.hours.toLocaleString()} hours, </span>
        <span>{timeLeft?.minutes.toLocaleString()} minutes, </span>
        <span>{timeLeft?.seconds.toLocaleString()} seconds</span>
      </div>
    );
  };

  const renderBidTime = (startTimeLeft, endTimeLeft, windowDates) => {
    if (!startTimeLeft && startTimeLeft !== undefined) {
      if (endTimeLeft) {
        return <div>{renderDateAndTimes("closes", endTimeLeft)}</div>;
      }
      return (
        <span>
          Bid closed at {getShiftDate(windowDates[1])}, {windowDates[1].toFormat("HH:mm ZZZZ")}
        </span>
      );
    }
    if (startTimeLeft) {
      return <div>{renderDateAndTimes("opens", startTimeLeft)}</div>;
    }
  };

  return <div>{renderBidTime(startTimeLeft, endTimeLeft, props.windowDates)}</div>;
};

BidTimer.propTypes = {
  windowDates: PropTypes.array.isRequired,
  station: PropTypes.string.isRequired,
};

export default BidTimer;
